<template>
  <div class="veda-product">
    <div class="web-box top">
      <a-row>
        <a-col :xs="24" :sm="12">
          <div style="max-width:500px;margin:0 auto">
            <h2>VEDA Marketing DMP</h2>
            <p>精准的商业数据管理平台</p>
          </div>
        </a-col>
        <a-col :xs="24" :sm="12">
          <div class="animo-wrap web-show">
            <img
              class="top-img"
              src="http://www.vedamobi.com/assets/website/images/dmp/top.png"
            />
            <div class="box1 box"></div>
            <div class="lightbeam lightbeam1"></div>
            <div class="box2 box"></div>
            <div class="lightbeam lightbeam2"></div>
          </div>
          <img
            class="top-img mobile-show"
            src="http://www.vedamobi.com/assets/website/images/dmp/top.png"
          />
        </a-col>
      </a-row>
    </div>
    <div class="label-wrap">
      <h4>VEDA Maketing DMP</h4>
      <div></div>
      <p>分散数据整合技术管理平台</p>
    </div>
    <div class="web-box content">
      <a-row>
        <a-col :xs="24" :sm="12">
          <img
            class="left"
            src="http://www.vedamobi.com/assets/website/images/dmp/content2.png"
          />
        </a-col>
        <a-col :xs="24" :sm="12">
          <div class="text-wrap right">
            <p class="text">
              打通多方平台数据
              <br />- 支持第一方媒体DMP数据 <br />- 支持VEDA自建DMP数据 <br />-
              支持第三方数据平台DMP数据 <br />- 支持第三方数据平台DMP数据
            </p>
            <p class="button" @click="goCallUs">联系我们</p>
          </div>
        </a-col>
      </a-row>
    </div>
    <div class="web-box content">
      <a-row>
        <a-col :xs="24" :sm="12">
          <div class="text-wrap left">
            <p class="text">
              开放DMP技术服务
              <br />- 支持 VEDA 前置机部署 <br />- 提供合理、程序化的计费方式
              <br />- 共享 VEDA 定向数据资源 <br />-
              低门槛接入，节省服务器和开发人力成本
            </p>
            <p class="button" @click="goCallUs">联系我们</p>
          </div>
        </a-col>
        <a-col :xs="24" :sm="12">
          <img
            class="right"
            src="http://www.vedamobi.com/assets/website/images/dmp/content1.png"
          />
        </a-col>
      </a-row>
    </div>
  </div>
</template>
<script>
import ScrollReveal from 'scrollreveal'
export default {
  data () {
    return {
      scrollReveal: ScrollReveal()
    }
  },

  mounted () {
    this.scrollReveal.reveal(`.left`, {
      // 动画的时长
      duration: 600,
      // 延迟时间
      delay: 200,
      // 动画开始的位置，'bottom', 'left', 'top', 'right'
      origin: 'left',
      // 回滚的时候是否再次触发动画
      reset: true,
      // 在移动端是否使用动画
      mobile: false,
      // 滚动的距离，单位可以用%，rem等
      distance: '200px',
      // 其他可用的动画效果
      opacity: 0.001,
      easing: 'linear'
    })
    this.scrollReveal.reveal(`.right`, {
      // 动画的时长
      duration: 600,
      // 延迟时间
      delay: 200,
      // 动画开始的位置，'bottom', 'left', 'top', 'right'
      origin: 'right',
      // 回滚的时候是否再次触发动画
      reset: true,
      // 在移动端是否使用动画
      mobile: false,
      // 滚动的距离，单位可以用%，rem等
      distance: '200px',
      // 其他可用的动画效果
      opacity: 0.001,
      easing: 'linear'
    })
  },
  methods: {
    goCallUs () {
      const btn = document.getElementById('callusForm')
      const scrollHeight = btn.offsetTop
      window.scrollTo(0, scrollHeight)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/product_page.scss';
.animo-wrap {
  margin: 0 auto;
  position: relative;
  width: 800px;
  height: 800px;
  .box {
    border-radius: 3px;

    position: absolute;
    transform: rotateX(55deg) rotateZ(45deg);
    background-image: linear-gradient(to top left, #fcbd66, #ef70b8);
    z-index: 3;
  }
  .box1 {
    width: 66px;
    height: 66px;
    top: 229px;
    left: 110px;
  }
  .lightbeam {
    transform: scaleY(0);
    transform-origin: 0 100%;
    background-image: linear-gradient(to top, #f5a9a9, transparent);
  }
  .lightbeam1 {
    width: 92px;
    height: 260px;
    position: absolute;
    top: 3px;
    left: 98px;
    animation: box3DAnimo1 1.8s linear infinite;
  }
  .box2 {
    width: 72px;
    height: 72px;
    bottom: 227px;
    right: 56px;
  }
  .lightbeam2 {
    width: 98px;
    height: 260px;
    position: absolute;
    bottom: 262px;
    right: 43px;
    animation: box3DAnimo1 2.1s linear infinite;
  }
}
@keyframes box3DAnimo1 {
  0% {
    opacity: 1;
    transform: scaleY(0);
  }
  20% {
    transform: scaleY(1);
  }
  70% {
    transform: scaleY(1);
  }
  100% {
    opacity: 0;
  }
}
</style>
